import {resetReportType} from 'ducks/reportType';
import {updateFilters} from 'ducks/filters';

export default function chooseReportType(reportType) {
  return (dispatch, getState) => {
    dispatch(resetReportType(reportType, {priority: true, savePreference: true}));
    const {filters, propertyDetail} = getState();
    if (reportType === 'soi') {

      const newFilters = {...filters};

      if (propertyDetail.metroProperty) {
        newFilters.radius = '2';
        newFilters.withinMonths = '6';
      } else {
        newFilters.radius = '5';
        newFilters.withinMonths = '18';
      }

      dispatch(updateFilters(newFilters, propertyDetail.propertyId !== undefined));
    }
  };
}
